const MuiInputLabel = {
  styleOverrides: {
    outlined: {
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
    },
  },
};

export default MuiInputLabel;
